import React from 'react'
import './Footer.css';

const Footer = () => {
  return (
    <div className='footer'>
      <p>Designed and Developed by Yash Gaur</p>
       {/* <a href="https://github.com/THEYASHGAUR/ReactJS-Portfolio" >Github link</a>  */}
    </div>
  )
}

export default Footer
